import { useProduct } from "../store/product";
import { round } from "../lib/utils";
import l10n from "../lib/l10n";
import { useCropperStore } from "../store/cropper/cropper-store";

const useTotals = () => {
  const preset = useCropperStore(s => s.preset);
  const product = useProduct(state => state.product);
  
  const getSquareMeters = (
    precise, 
    sqmt = ((preset.width / 100) * preset.height) / 100
  ) => precise ? round(sqmt, 2) : sqmt;

  const getMediaPrice = (wholesalePrice = false) => {
    const priceLabel = wholesalePrice ? 'wholesale_price' : 'price';
    return (
      preset.media 
        ? product.media.filter(({ sku }) => sku === preset.media)[0][priceLabel]
        : product.media[0][priceLabel]
    );
  };

  const getPricePerSquareMeter = (wholesalePrice = false) => {
    const priceLabel = wholesalePrice ? 'price_sqmt_wholesale' : 'price_sqmt';
    return (
      Number(product[priceLabel]) 
    + Number(getMediaPrice(wholesalePrice))
    );
  }
  
  const getTotals = (wholesalePrice = false) => {
    
    const price = (
      getPricePerSquareMeter(wholesalePrice)
    * getSquareMeters()
    );

    return new Intl.NumberFormat(l10n.lang,
      { 
        // trailingZeroDisplay: 'stripIfInteger',
        minimumFractionDigits: 2 
      }
    ).format( round(price, 2) );
  };

  const getPublicPrice = () => `${l10n.currency_symbol}${getTotals()}`;
  const getWholesalePrice = () => `${l10n.currency_symbol}${getTotals(true)}`;

  return {
    getSquareMeters,
    getMediaPrice,
    getPricePerSquareMeter,
    getTotals,
    getPublicPrice,
    getWholesalePrice
  }
};

export default useTotals;